import React from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
import { statusMeta, priorityMeta } from '../../utils/kitchenTasks';

export const StatusBadge = ({ status, isLate, className = '' }) => {
  const meta = statusMeta(status);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${meta.cls} ${className}`} data-testid={`status-badge-${status}`}>
      <span className={`w-2 h-2 rounded-full ${meta.dot}`} />
      {meta.label}
      {isLate && <span className="inline-flex items-center gap-0.5 text-red-700 ml-1" title="En retard"><Clock size={11} />Retard</span>}
    </span>
  );
};

export const PriorityBadge = ({ priority, className = '' }) => {
  const meta = priorityMeta(priority);
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-xs font-semibold ${meta.cls} ${className}`} data-testid={`priority-badge-${priority}`}>
      {priority === 'urgente' && <AlertTriangle size={11} />}
      {meta.label}
    </span>
  );
};
